var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.customerTablesFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTablesEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTablesEntegration", $$v)
                  },
                  expression: "featureForm.customerTablesEntegration",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.customerTable")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableLinkedFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableLinkedFeature", $$v)
                  },
                  expression: "featureForm.customerTableLinkedFeature",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.tableAssociation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableAIFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableAIFeature", $$v)
                  },
                  expression: "featureForm.customerTableAIFeature",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.aiSupportedRecord")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableModuleFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableModuleFeature", $$v)
                  },
                  expression: "featureForm.customerTableModuleFeature",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.tableModularization")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customerTableReportFeature,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customerTableReportFeature", $$v)
                  },
                  expression: "featureForm.customerTableReportFeature",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.tableReportCreation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.tableCreationLimit"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableCount", $$v)
                },
                expression: "featureForm.customerTableCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.fieldsPerTable"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableFieldCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableFieldCount", $$v)
                },
                expression: "featureForm.customerTableFieldCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.recordsPerTable"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableRecordCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableRecordCount", $$v)
                },
                expression: "featureForm.customerTableRecordCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.viewsPerTable"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.customerTableViewCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "customerTableViewCount", $$v)
                },
                expression: "featureForm.customerTableViewCount",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }